import { DynamicMessageBoxComponent } from '@app/shared/message-box/components/dynamic-message-box/dynamic-message-box.component';

export const components = [DynamicMessageBoxComponent];

export * from './dynamic-message-box/dynamic-message-box.component';
